import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import moment, { Moment } from "moment";
import { useField, useFormikContext } from "formik";

type DateTimePickerFieldProps = {
    name: string;
    label: string;
    format: string;
    minDateTime: Moment;
    className: string;
};

const DateTimePickerField = ({name,label,format,minDateTime,className}:DateTimePickerFieldProps) => {
    const { setFieldValue, setFieldTouched } = useFormikContext();
    const [field, meta] = useField(name);

    const hasError = meta.touched && Boolean(meta.error);

    return (
        <LocalizationProvider dateAdapter={AdapterMoment}>
            <DateTimePicker
                label={label}
                format={format}
                minDateTime={minDateTime}
                closeOnSelect={false}
                value={
                    field.value
                        ? moment(field.value, format)
                        : null
                }
                onChange={(value: any) => {
                    setFieldValue(
                        name,
                        value ? value.format(format) : null
                    );
                }}
                onClose={() => {
                    setFieldTouched(name, true);
                }}
                slotProps={{
                    textField: {
                        helperText: hasError ? meta.error : null,
                        error: hasError,
                        className,
                    },
                }}
            />
        </LocalizationProvider>
    );
};

export default DateTimePickerField;